import React from "react";
import './style.scss';
import SliderBar from "../../components/slider";
import {Input,Label} from "semantic-ui-react";
import '../../components/text-input/style.scss'
import PageHeader from "../../components/page-header";
import TextInput from "../../components/text-input";
export default class PetPreferenceDetails extends React.Component {
    state = {
        budget: ''
    }

    handleChange(element){
        let {name, value} = element;
        this.setState({
            [name]: value
        })
    }

    render() {
        return(
            <div className={"pet-preference"}>
                <PageHeader text='Available base on your needs' history={this.props.history} />
            <div className={"pet-preference-info form-group"}>
                <TextInput label={"What is your budget to spend on your future pet?"} value={this.state.budget} name={"budget"} handleChange= {this.handleChange.bind(this)}/>
                <label>How many hours can you spend with your future pet?</label>
                <SliderBar/>
            </div>
            </div>
        );
    }
}
